import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Mail, Phone, MapPin, Instagram, Twitter, Linkedin } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-primary-950 text-neutral-300 pt-16 pb-8" data-id="element-167">
      <div className="container mx-auto px-4 md:px-6" data-id="element-168">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-169">
          {/* Brand */}
          <div data-id="element-170">
            <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-171">
              <div className="w-8 h-8 rounded bg-secondary flex items-center justify-center font-serif font-bold text-xl text-primary-900" data-id="element-172">
                A
              </div>
              <span className="font-serif font-bold text-2xl tracking-tight text-white" data-id="element-173">
                AMU
              </span>
            </Link>
            <p className="text-sm leading-relaxed mb-6" data-id="element-174">
              The premium Abuja real estate marketplace. Discover verified land
              and property listings directly from trusted owners and authorized
              sellers.
            </p>
            <div className="flex items-center gap-4" data-id="element-175">
              <a href="#" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-secondary hover:text-white transition-colors" data-id="element-176">
                <Instagram size={16} data-id="element-177" />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-secondary hover:text-white transition-colors" data-id="element-178">
                <Twitter size={16} data-id="element-179" />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-secondary hover:text-white transition-colors" data-id="element-180">
                <Linkedin size={16} data-id="element-181" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-182">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-183">Explore</h4>
            <ul className="space-y-3" data-id="element-184">
              <li data-id="element-185">
                <Link to="/explore" className="text-sm hover:text-secondary transition-colors" data-id="element-186">
                  All Properties
                </Link>
              </li>
              <li data-id="element-187">
                <Link to="/explore?tier=1" className="text-sm hover:text-secondary transition-colors" data-id="element-188">
                  Tier 1 Listings
                </Link>
              </li>
              <li data-id="element-189">
                <Link to="/map" className="text-sm hover:text-secondary transition-colors" data-id="element-190">
                  Map Discovery
                </Link>
              </li>
              <li data-id="element-191">
                <Link to="/list-property" className="text-sm hover:text-secondary transition-colors" data-id="element-192">
                  List Your Property
                </Link>
              </li>
              <li data-id="element-193">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-194">
                  About AMU
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-195">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-196">
              Legal & Trust
            </h4>
            <ul className="space-y-3" data-id="element-197">
              <li data-id="element-198">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-199">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-200">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-201">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-202">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-203">
                  Verification Process
                </Link>
              </li>
              <li data-id="element-204">
                <Link to="/about" className="text-sm hover:text-secondary transition-colors" data-id="element-205">
                  Fraud Prevention
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-206">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-207">Contact</h4>
            <ul className="space-y-4" data-id="element-208">
              <li className="flex items-start gap-3" data-id="element-209">
                <MapPin size={18} className="text-secondary shrink-0 mt-0.5" data-id="element-210" />
                <span className="text-sm" data-id="element-211">
                  14 Maitama Crescent, Abuja, FCT, Nigeria
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-212">
                <Phone size={18} className="text-secondary shrink-0" data-id="element-213" />
                <span className="text-sm" data-id="element-214">+234 (0) 800 AMU REAL</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-215">
                <Mail size={18} className="text-secondary shrink-0" data-id="element-216" />
                <span className="text-sm" data-id="element-217">support@amu.ng</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust Banner & Copyright */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-218">
          <div className="flex items-center gap-2 text-sm text-white/70" data-id="element-219">
            <ShieldCheck size={18} className="text-success" data-id="element-220" />
            <span data-id="element-221">
              All listings are subject to AGIS/FCDA verification standards.
            </span>
          </div>
          <p className="text-sm text-white/50" data-id="element-222">
            &copy; {new Date().getFullYear()} AMU Real Estate. All rights
            reserved.
          </p>
        </div>

        {/* Designed by Credit */}
        <div className="mt-6 pt-6 border-t border-white/5 text-center" data-id="element-223">
          <p className="text-xs text-white/40 tracking-wider uppercase" data-id="element-224">
            Designed by{' '}
            <a href="#" className="text-secondary hover:text-secondary-dark font-semibold transition-colors" data-id="element-225">
              KM Consulting &amp; Tech LTD
            </a>
          </p>
        </div>
      </div>
    </footer>;
};